import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppStorage } from '@app/common/services/data-api/app-storage.service';
import { PxdGridMenuService } from '@app/shared/kendoui/grid/components/pxd-grid-menu/pxd-grid-menu.service';
import { PxdColumns } from '@app/shared/kendoui/grid/interfaces/pxd-columns';
import { skipProjectColumn } from '@app/shared/library/constant';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { GridComponent } from '@progress/kendo-angular-grid';
import { CheckBoxDirective } from '@progress/kendo-angular-inputs';
import { PopupComponent } from '@progress/kendo-angular-popup';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'pxd-grid-menu',
  templateUrl: './pxd-grid-menu.component.html',
  styleUrls: ['./pxd-grid-menu.component.scss'],
  providers: [PxdGridMenuService],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    CheckBoxDirective,
    FormsModule,
    PopupComponent,
  ],
})
export class PxdGridMenuComponent implements OnInit {
  private store = inject(AppStorage);
  public pxdGridMenuService = inject(PxdGridMenuService);


  public icons = kendoIcons;
  public svc: PxdGridMenuService;

  constructor() {
    this.svc = this.pxdGridMenuService;
  }

  readonly columns = input<PxdColumns[]>(undefined);
  private _columns: PxdColumns[] = [];
  readonly grid = input<GridComponent>(undefined);
  readonly columnSettingsKey = input<string>(undefined);
  private _columnSettingsKey: string = '';
  filteredColumns: PxdColumns[];

  public ngOnInit(): void {
    this._columns = this.columns();
    this._columnSettingsKey = this.columnSettingsKey();
    if (this._columns && this._columns.length) {
      this.store.knownEvents.assetTeamSelected
        .pipe(
          filter(selected => !!selected),
          map(() => this._columns.filter(col => !skipProjectColumn.includes(col.title)))
        )
        .subscribe(filtered => {
          this.filteredColumns = filtered;
          this.svc.init(filtered, this.grid(), this._columnSettingsKey);
        });
    }
  }

  public refresh(columns: PxdColumns[], columnSettingsKey: string) {
    this._columns = columns;
    this._columnSettingsKey = columnSettingsKey;

    this.svc.init(this._columns, this.grid(), this._columnSettingsKey);
  }
}